export enum PageHeaderEnum {
  OcAcCalculator = 'Kalkulator OC AC',
  YoutData = 'Twoje dane',
}
